import React, { useRef, useEffect } from 'react';

const LogDisplay = ({ 
  logs, 
  websocketLogs, 
  showLog,
  setShowLog,
  showWebsocketLog, 
  setShowWebsocketLog 
}) => {
  const logEndRef = useRef(null);

  // Auto-scroll logs to bottom
  useEffect(() => {
    if (logEndRef.current) {
      const logContainer = logEndRef.current.closest('.log-container');
      if (logContainer) {
        logContainer.scrollTop = logContainer.scrollHeight;
      }
    }
  }, [logs, websocketLogs]);

  return (
    <>
      {/* Main Log */}
      <div className="log-container">
        <div className="log-header">
          <button 
            onClick={() => setShowLog(!showLog)}
            className="log-toggle-btn"
          >
            {showLog ? 'Hide' : 'Show'} Main Log
          </button>
          <span className="log-count">
            {logs.length} messages
          </span>
        </div>
        
        {showLog && (
          <div className="log-messages">
            {logs.length === 0 ? (
              <div className="log-empty">No log messages yet...</div>
            ) : (
              logs.map((log, index) => (
                <div key={index} className="log-message">
                  <span className="log-timestamp">[{log.timestamp}]</span>
                  <span className="log-content">{log.message}</span>
                </div>
              ))
            )}
            <div ref={logEndRef} />
          </div>
        )}
      </div>

      {/* WebSocket Log */}
      <div className="websocket-log-container">
        <div className="websocket-log-header">
          <button 
            onClick={() => setShowWebsocketLog(!showWebsocketLog)}
            className="log-toggle-btn"
          >
            {showWebsocketLog ? 'Hide' : 'Show'} WebSocket Log
          </button>
          <span className="log-count">
            {websocketLogs.length} messages
          </span>
        </div>
        
        {showWebsocketLog && (
          <div className="websocket-log-messages">
            {websocketLogs.length === 0 ? (
              <div className="websocket-log-empty">No WebSocket messages yet...</div>
            ) : (
              websocketLogs.map((log, index) => (
                <div key={index} className="websocket-log-entry">
                  <div className="websocket-log-header">
                    <span className="websocket-log-timestamp">[{log.timestamp}]</span>
                    <span className="websocket-log-type">{log.type}</span>
                  </div>
                  <div className="websocket-log-data">
                    {typeof log.data === 'object' ? 
                      JSON.stringify(log.data, null, 2) : 
                      String(log.data)
                    }
                  </div>
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default LogDisplay;
